<script setup>
import { computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const query = computed(() => {
  const query = route.query
  return {
    service: query.service,
    token: query.token,
  }
})

onMounted(async () => {
  if (!query.value.token) {
    router.push({ name: 'login' })
    return
  }
})
</script>
<template></template>
